import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { CourtesyLoanStatus } from '@/hooks/useCourtesyVehicles';

const STATUS_COLOR: Record<CourtesyLoanStatus, 'info' | 'warning' | 'success' | 'default'> = {
  reserved: 'info',
  out: 'warning',
  returned: 'success',
  cancelled: 'default',
};

interface CourtesyLoanStatusChipProps {
  status: CourtesyLoanStatus;
  size?: 'small' | 'medium';
}

export function CourtesyLoanStatusChip({ status, size = 'small' }: CourtesyLoanStatusChipProps) {
  const { t } = useTranslation('workorders');
  return (
    <Chip
      size={size}
      color={STATUS_COLOR[status]}
      label={t(`courtesy.status.${status}`)}
    />
  );
}

export const COURTESY_LOAN_BAR_COLOR: Record<CourtesyLoanStatus, string> = {
  reserved: 'info.main',
  out: 'warning.main',
  returned: 'success.main',
  cancelled: 'action.disabled',
};
